import React, { useLayoutEffect, useEffect, useState, useRef } from "react";
import './event.css';
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import 'aos/dist/aos.css';
import { FaRegHeart } from 'react-icons/fa';
import img from '../../Assets/disabilityHistoryMonth2024/1.jpg'
import img2 from '../../Assets/disabilityHistoryMonth2024/2.jpg'
import img3 from '../../Assets/disabilityHistoryMonth2024/3.jpg'
import img4 from '../../Assets/disabilityHistoryMonth2024/4.jpg'
import img5 from '../../Assets/disabilityHistoryMonth2024/5.jpg'
import o1 from '../../Assets/OpenDay2025/o1.jpeg'
import o2 from '../../Assets/OpenDay2025/o2.jpeg'
import p0 from '../../Assets/potentialUnlockAward/p0.jpg'
import p1 from '../../Assets/potentialUnlockAward/p1.jpg'
import p2 from '../../Assets/potentialUnlockAward/p2.jpg'
import p3 from '../../Assets/potentialUnlockAward/p3.jpg'
import p4 from '../../Assets/potentialUnlockAward/p4.jpg'
import p5 from '../../Assets/potentialUnlockAward/p5.jpg'
import p6 from '../../Assets/potentialUnlockAward/p6.jpg'
import p7 from '../../Assets/potentialUnlockAward/p7.jpg'
import p8 from '../../Assets/potentialUnlockAward/p8.jpg'
import p9 from '../../Assets/potentialUnlockAward/p9.jpg'
import p10 from '../../Assets/potentialUnlockAward/p10.jpg'
import p11 from '../../Assets/potentialUnlockAward/p11.PNG'
import p13 from '../../Assets/potentialUnlockAward/p13.jpg'
import p14 from '../../Assets/potentialUnlockAward/p14.jpg'
import s1 from '../../Assets/SocietyofYear/s1.jpeg'
import s2 from '../../Assets/SocietyofYear/s2.jpg'
import s3 from '../../Assets/SocietyofYear/s3.jpg'
import s4 from '../../Assets/SocietyofYear/s4.jpg'
import s5 from '../../Assets/SocietyofYear/s5.jpg'
import a1 from '../../Assets/fiveanniversary/1.jpeg'
import a2 from '../../Assets/fiveanniversary/2.jpeg'
import a3 from '../../Assets/fiveanniversary/3.jpeg'
import a4 from '../../Assets/fiveanniversary/4.jpeg'
import a5 from '../../Assets/fiveanniversary/5.jpeg'
import a6 from '../../Assets/fiveanniversary/6.jpeg'
import a7 from '../../Assets/fiveanniversary/7.jpeg'

const GAP = 20;
const events = [

  {
    id: 1,
    images: [a6, a7, a4, a5, a3, a2, a1],
    eventDescription: 'Legalnable Turns Five',
    location: 'FreshField Law Firm, Manchester',
    eventTitle: 'Legalnable Five Anniversary'

  },
  {
    id: 2,
    images: [img, img2, img3, img4, img5],
    eventDescription: 'Disability History Month 2025',
    location: 'University of Wolverhampton',
    eventTitle: 'Disability History Month 2024'

  },
  {
    id: 3,
    images: [o1, o2],
    eventDescription: 'Campus Open Day',
    location: 'University of Wolverhampton',
    eventTitle: 'Open Day 2025'

  },

  {
    id: 4,
    images: [p1, p2, p0, p3, p4, p5, p6, p7, p8, p9, p10, p11, p13, p14],
    eventDescription: 'Potential Unlock Award',
    location: 'Birmingham',
    eventTitle: 'Potential Unlock Award'

  },

  {
    id: 5,
    images: [s1, s2, s3, s4, s5],
    eventDescription: 'Society of Year 2024',
    location: 'University of Wolverhampton',
    eventTitle: 'Legalnable Awards'

  },
  {
    id: 6,
    images: [img, img],
    eventDescription: 'Disability rights',
    location: 'Legal aid',
    eventTitle: 'Legal Support'

  },
]
const Event = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);
  const containerRef = useRef(null);
  const cardRef = useRef(null);
  const [cardsPerView, setCardsPerView] = useState(3);

  const [imageIndexes, setImageIndexes] = useState({});
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1024) setCardsPerView(3);      
      else if (width >= 768) setCardsPerView(2);   
      else setCardsPerView(1);                    
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const initialIndexes = {};
    events.forEach(event => {
      initialIndexes[event.id] = 0;
    });
    setImageIndexes(initialIndexes);
  }, []);

  const handleImageNext = (id, imageCount) => {
    setImageIndexes(prev => ({
      ...prev,
      [id]: ((prev[id] ?? 0) + 1) % imageCount,
    }));
  };

  const handleImagePrev = (id, imageCount) => {
    setImageIndexes(prev => ({
      ...prev,
      [id]: ((prev[id] ?? 0) - 1 + imageCount) % imageCount,
    }));
  };

  useLayoutEffect(() => {
    const updateWidths = () => {
      const gap = GAP;
      let newCardWidth = 0;

      if (window.innerWidth >= 1024) {
        newCardWidth = 300 + gap; // Desktop
      } else if (window.innerWidth >= 768) {
        newCardWidth = 300 + gap; // Tablet
      } else {
        newCardWidth = window.innerWidth * 0.9 + gap;  
      }

      setCardWidth(newCardWidth);
      setPageIndex(0);  
    };

    updateWidths();
    window.addEventListener("resize", updateWidths);
    return () => window.removeEventListener("resize", updateWidths);
  }, [cardsPerView]);


  const maxIndex = Math.max(events.length - cardsPerView, 0);


  useEffect(() => {
    if (pageIndex > maxIndex) {
      setPageIndex(maxIndex);
    }
  }, [maxIndex]);


  // onClick handlers
  const handleLeft = () => {
    setPageIndex(prev => {
      const next = Math.max(prev - 1, 0);
      return next;
    });
  };

  const handleRight = () => {
    setPageIndex(prev => {
      const next = Math.min(prev + 1, maxIndex);
      return next;
    });
  };
  return (
    <section className="popular section container">
      <div className="secContainer">
        <div className="secHeader flex">
          <div data-aos="fade-right" className="textDiv">
            <h2 className="secTitle">Events</h2>
            <p>Stay connected with Legalnable through our upcoming workshops, awareness campaigns, and community meetups.</p>
          </div>

          <div data-aos="fade-left" className="iconsDiv flex">
            <IoMdArrowBack
              className="icon leftIcon"
              onClick={handleLeft}
              style={{ cursor: pageIndex === 0 ? "not-allowed" : "pointer" }}
            />
            <IoMdArrowForward
              className="icon"
              onClick={handleRight}
              style={{ cursor: pageIndex === maxIndex ? "not-allowed" : "pointer" }}
            />
          </div>
        </div>

        <div className="scrollWrapper" ref={containerRef} style={{ overflow: "hidden" }}>
          <div
            className="mainContent"
            style={{
              display: "flex",
              gap: `${GAP}px`,
              transform: `translateX(-${pageIndex * cardWidth}px)`,
              transition: "transform 0.5s ease"
            }}
          >
            {events.map(({ id, images, eventDescription, location, eventTitle }, index) => {
              const currentImageIndex = typeof imageIndexes[id] === 'number' ? imageIndexes[id] : 0;

              return (
                <div
                  key={id}
                  className="singleEvent"
                  data-aos="fade-up"
                  style={{
                    flex: "0 0 auto",
                    width: `${cardWidth - GAP}px`,
                  }}
                >
                  <div className="eventImage" style={{ position: 'relative' }}>
                    <img
                      key={currentImageIndex}
                      src={images[currentImageIndex]}
                      alt="Event"
                      style={{ width: "100%", height: "250px", objectFit: "cover" }}
                    />
                    <IoIosArrowBack
                      size={30}
                      onClick={() => handleImagePrev(id, images.length)}
                      className="arrowIcon arrow-left"
                    />

                    <IoIosArrowForward
                      size={30}
                      onClick={() => handleImageNext(id, images.length)}
                      className="arrowIcon arrow-right"
                    />

                    <div className={`overlayInfo ${currentImageIndex !== 0 ? 'hiddenOverlay' : ''}`}>
                      <h3>{eventDescription}</h3>
                      <p>{location}</p>
                    </div>
                  </div>
                  <div className="eventFooter">
                    <div className="number"><FaRegHeart /></div>
                    <div className="eventText flex"><h6>{eventTitle}</h6></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Event;
